<template>
  <ConfigProvider :theme="themeConfig" :locale="locale">
      <RouterView />
  </ConfigProvider>
</template>

<script setup>
  import { ConfigProvider } from 'ant-design-vue';
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import { reactive,onMounted } from 'vue';
  import { getToken } from '@/utils/auth'
  import dayjs from 'dayjs';
  import 'dayjs/locale/zh-cn';
  const locale=zhCN
  import { getSysDictVOListTree, getSysDictsByTypeCode } from '@/api/system/dict/data.js'
import useAppStore from "@/store/modules/app";
const appStore = useAppStore();



  const themeConfig = reactive({
    
  "token": {
    "colorPrimary": "#186FF2",
    "colorInfo": "#186FF2",
    "borderRadius": 4,
    "wireframe": false,
    "colorPrimaryActive": "#0A51CC",
    "colorPrimaryBg": "#d5e4eb",
    "colorTextBase": "#0a212e",
    "colorPrimaryHover": "#4294FF"
  },
  "components": {
    "Menu": {
      "colorGroupTitle": "#0A212E",
      "colorItemTextSelected": "#186FF2",
      "colorItemTextSelectedHorizontal": "#186FF2",
      "colorItemTextHoverHorizontal": "#4294FF",
      "controlItemBgActive": "#d5e4eb",
      "colorItemBgSelected": "#e6f4ff"
    },
    "Input": {
      "colorBgContainer": "#F2F4F7",
    },
    "Select": {
      "colorBgContainer": "#F2F4F7",
    },
    "Form": {
      "colorTextHeading": "rgba(29, 33, 41, 1)"
    },
    "DatePicker": {
      "colorBgContainer": "#F2F4F7"
    }
  }

    // token: {
    //   colorPrimary: '#1890ff',
    // },
    // components: {},
    
  // token: {
  //   "wireframe": false,
  //   "colorPrimary": "red",
  //   "colorInfo": "#006aff"
  // },
  // components: {
  //   Button: {
  //     'defaultColor':"green",
  //     "colorPrimary": "red",
  //     "colorError": "pink",
  //     "colorErrorActive":"red"
  //   },
  //   Tag: {
  //     "defaultBg": "red",
  //     "defaultColor": "rgba(210, 32, 32, 0.88)",
  //     "colorSuccess":"red",
  //     "colorSuccessBg":"yellow"
  //   }
  // }

  });






const getList = () => {
  getSysDictVOListTree().then(res=>{
    appStore.setSysDictVOList(res.data || [])
  })
}

if(getToken()){
  getList()
}






</script>

<style lang="less" >
  
#app{
  background: url(~@/assets/images/bg.png) no-repeat;
  background-size: cover;
}
</style>

